import { createStore, compose, applyMiddleware } from 'redux';

export default (reducers, middlewares) => {
  const composer = compose(applyMiddleware(...middlewares));

  return createStore(reducers, composer);
};
